import React, { useState } from 'react';
import CountUp from 'react-countup';
import ScrollTrigger from 'react-scroll-trigger';

const Counter = () => {
    const [counterOn, setCounterOn] = useState(false);

    return (
        <div className="home-counter">
                <div className="container c_container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer-header text-center">
                                <h6 className="text-white" data-aos="fade-up">Statistics</h6>
                                <h3 className="heading-1fff text-white" data-aos="fade-up">Our Numbers Shown Our Success Parameters</h3>
                            </div>
                            <div className="footer-counter">
                                <div className="row" id="counter">
                                    <div className="col-md-4" data-aos="fade-up" data-aos-duration={1500}>
                                        <div className="footer-count text-center">
                                            <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)} >
                                                {counterOn && <CountUp start={0} end={2500} duration={2} delay={0}/>}<span>+</span>
                                            </ScrollTrigger>                
                                            <p>Mobile X-rays to <br />performed date</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4" data-aos="fade-up" data-aos-duration={2500}>
                                        <div className="footer-count text-center">
                                            <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                                {counterOn && <CountUp start={0} end={89} duration={2} delay={0} />}<span>%</span>
                                            </ScrollTrigger>
                                            <p>Prevented emergency <br />department transfer</p>
                                        </div>
                                    </div>
                                    <div className="col-md-4" data-aos="fade-up" data-aos-duration={3000}>
                                        <div className="footer-count text-center">
                                            <ScrollTrigger onEnter={()=> setCounterOn(true)} onExit={() => setCounterOn(false)}>
                                                {counterOn && <CountUp start={0} end={1} duration={0} delay={0 }/>}<span>st</span>
                                            </ScrollTrigger>
                                            <p>and only Mobile X-ray <br />licensee in India</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default Counter;